import React from "react"
import "./select.scss"

const Select = ({ label, children, register, error, ...restSelect }) => {
  return (
    <div className="f-select-wrapper">
      {label && <label>{label}</label>}
      <select className="f-select-atom" {...restSelect} ref={register}>
        {children}
      </select>
      <span className="icon-down icon-select" />
      {error && <span className="f-error-input"> {error?.message} </span>}
    </div>
  )
}

export default Select
